<template>
  <q-dialog v-model="fileVersionAdminDialog">
    <q-card
      class="resultsModal"
      style="min-width: 100%; min-height: 100%; border-radius: 10px; overflow-x: hidden;"
    >
      <q-card-section align="center">
        <div style="float: right"><q-btn icon="close" flat round dense v-close-popup class="circle-btn text-primary" style="margin-bottom: 0px" /></div>
        <div class="text-h6" style="font-weight: bold">{{ fileName }}</div>
      </q-card-section>

      <q-card-section class="q-pt-none" align="center" style="margin-top: 150px" v-if="!rowData">
        <div class="spinner">
          <div class="loading-text" style="line-height: 22px">
            <img src="fd-logo.svg">
          </div>
          <div class="spinner-item"></div>
          <div class="spinner-item"></div>
        </div>
      </q-card-section>

      <q-card-section class="q-pt-none" align="center" style="margin-top: 50px" v-if="rowData">
        <q-table
          :columns="columnDefs"
          :pagination="pagination"
          :rows="rowData"
          virtual-scroll
          wrap-cells
          hide-pagination
          class="tableClass"
        >
          <template v-slot:body-cell-emphasize="props">
            <q-td :props="props">
              <div style="display: flex; align-items: center; justify-content: center;">
                <q-checkbox v-model="emphasizeFileId" :val="props.row.id" />
              </div>
            </q-td>
          </template>
          <template v-slot:body-cell-hide="props">
            <q-td :props="props">
              <div style="display: flex; align-items: center; justify-content: center;">
                <q-checkbox v-model="hiddenFileId" :val="props.row.id" />
              </div>
            </q-td>
          </template>
          <template v-slot:body-cell-delete="props">
            <q-td :props="props">
              <div style="display: flex; align-items: center; justify-content: center;">
                <q-btn
                  dense
                  round
                  flat
                  color="red"
                  @click="deleteRow(props)"
                  icon="delete"
                />
              </div>
            </q-td>
          </template>
        </q-table>
      </q-card-section>

      <q-card-actions align="center" class="text-primary" v-if="rowData">
        <q-btn
          label="Cancel"
          color="cancelButton"
          class="q-ml-sm dialogButton"
          no-caps
          v-close-popup
        />
        <q-btn
          label="Save"
          @click="saveFileVersionData"
          color="primary"
          class="dialogButton"
          no-caps
          v-close-popup
        />
      </q-card-actions>
    </q-card>
  </q-dialog>

  <q-dialog v-model="deleteDialog" transition-show="fade" transition-hide="fade">
    <div class="initialBackDrop" style="min-height: 100vh">
      <div class="q-pa-md q-gutter-sm" style="width: 80ex; margin-left: auto; margin-right: auto; margin-top: 5%; margin-bottom: auto; border-radius: 10px;">
        <q-card style="padding: 50px; border-radius: 10px;" class="q-pa-md">
          <div align="right"><q-btn icon="close" flat round dense v-close-popup class="circle-btn text-primary" style="margin: -70px -40px 0px 0px;" /></div>
          <div class="dialogText">{{deleteDialogMessage}}</div>

          <br />

          <q-card-actions align="center" class="text-primary">
            <q-btn
              label="Cancel"
              color="cancelButton"
              class="q-ml-sm dialogButton"
              no-caps
              v-close-popup
            />
            <q-btn
              label="Delete"
              @click="deleteRecord"
              color="primary"
              class="dialogButton"
              no-caps
              v-close-popup
            />
          </q-card-actions>
        </q-card>
      </div>
    </div>
  </q-dialog>
</template>

<script>
import { computed, ref, watch } from "vue";
import CommonHelper from "../helper/CommonHelper";
import NotificationHelper from "../helper/NotificationHelper";
import EmailService from "../service/EmailService.js";
import LogService from '../service/LogService';
import MayanService from '../service/MayanService';
import moment from "moment";

export default {
  name: "FileVersionAdmin",
  props: {
    currentUserUID: String,
    ipAddress: String,
    userDeleteAccessLevel: Boolean,
    filePreview: Object
  },
  setup(props) {
    const columnDefs = computed(() => {
      let returnValue = [
        { label: "Document Name", name: "label", field: "label", align: "left" },
        { label: "Date Created", name: "date", field: "date", align: "left" },
        { label: "Emphasize", name: "emphasize", field: "emphasize", align: "center" },
        { label: "Hide", name: "hide", field: "hide", align: "center" }
      ];

      if (props.userDeleteAccessLevel) {
        returnValue.push({ label: "Delete", name: "delete", field: "delete", align: "center" });
      }

      return returnValue;
    });

    const pagination = ref({ rowsPerPage: 0 })

    const rowData = ref(null);

    const fileVersionAdminDialog =  ref(false);
    const documentId = ref("");
    const fileName = ref("");
    const emphasizeFileId = ref([]);
    const hiddenFileId = ref([]);

    watch(emphasizeFileId, () => {
      if (emphasizeFileId.value.length > 1) {
        emphasizeFileId.value = [ emphasizeFileId.value[emphasizeFileId.value.length - 1] ];
      }
    });

    function openFileVersionAdmin(paramDocumentId, paramFileName) {
      documentId.value = paramDocumentId;
      fileName.value = paramFileName;
      fileVersionAdminDialog.value = true;

      updateStoredFileLatest();
    }

    async function updateStoredFileLatest() {
      rowData.value = null;

      await CommonHelper.updateStoredFileLatest(documentId.value, true);

      const fileLatest = CommonHelper.storedFileLatest.value[documentId.value];

      if (fileLatest) {
        rowData.value = fileLatest.map((file) => {
          let label = file.filename;

          if (label.includes(":::")) {
            label = label.split(":::")[1];
          }

          let date = moment(file.timestamp).format("MM-DD-YYYY hh:mm a" );

          return {
            id: file.id,
            label: label,
            date: date
          };
        });
      }

      emphasizeFileId.value = CommonHelper.currentFileVersionData.value.emphasizeFileId ? CommonHelper.currentFileVersionData.value.emphasizeFileId : [];
      hiddenFileId.value = CommonHelper.currentFileVersionData.value.hiddenFileId ? CommonHelper.currentFileVersionData.value.hiddenFileId : [];
    }

    async function saveFileVersionData() {
      try {
        NotificationHelper.createNotification("Saving...");

        const record = CommonHelper.tableInput.value.find((i) => {
          if (i.id === documentId.value) {
            return i;
          }
        });

        if (record) {
          let file_version_data_json = record.file_version_data ? JSON.parse(record.file_version_data) : {};

          file_version_data_json.emphasizeFileId = emphasizeFileId.value;
          file_version_data_json.hiddenFileId = hiddenFileId.value;

          record.file_version_data = JSON.stringify(file_version_data_json);
        }

        const response = await MayanService.editFileVersionData(documentId.value, emphasizeFileId.value.toString(), hiddenFileId.value.join(","));

        LogService.logDocumentChanges(props.currentUserUID, props.ipAddress, "Update", response);

        NotificationHelper.createSuccessNotification("Saved Successfully");
      } catch (error) {
        EmailService.sendErrorEmail("FileVersionAdmin.vue - saveFileVersionData", error);
        NotificationHelper.createErrorNotification("Error encountered. Please try again.");
      }
    }

    const deleteDialog =  ref(false);
    const fileId = ref("");
    const deleteDialogMessage = ref("");

    function deleteRow(paramProps) {
      fileId.value = paramProps.row.id;
      deleteDialogMessage.value = `Delete "${paramProps.row.label}" (${paramProps.row.date})?`;
      deleteDialog.value = true;
    }

    async function deleteRecord() {
      try {
        if (documentId.value && fileId.value) {
          const documentIdValue = documentId.value;
          const fileIdvalue = fileId.value;

          NotificationHelper.createNotification("Deleting File...");
          updateRefsBeforeResponse(documentIdValue, fileIdvalue);
          const response = await MayanService.deleteFileVersion(documentIdValue, fileIdvalue);
          LogService.logDocumentChanges(props.currentUserUID, props.ipAddress, "Update", response);
          updateRefsFromResponse(documentIdValue, response);

          NotificationHelper.createSuccessNotification("File Deleted Successfully");
        }
      } catch (error) {
        EmailService.sendErrorEmail("FileVersionAdmin.vue - deleteRecord", error);
        NotificationHelper.createErrorNotification("Error encountered. Please try again.");
      }
    }

    async function updateRefsBeforeResponse(documentIdValue, fileIdvalue) {
      const record = CommonHelper.tableInput.value.find((i) => {
        if (i.id === documentIdValue) {
          return i;
        }
      });

      if (record) {
        const file_count_new = record.file_count - 1;

        record.file_count = file_count_new;

        if (rowData.value[0].id === fileIdvalue) {
          props.filePreview.removeStoredBlobDocumentId(documentIdValue);

          const old_extension = getFilenameExtension(fileName.value);
          const new_extension = rowData.value[1] ? getFilenameExtension(rowData.value[1].label) : "";

          if (new_extension && old_extension !== new_extension) {
            const filenameExtensionIndex = fileName.value.lastIndexOf('.');
            const new_label = `${filenameExtensionIndex >= 0 ? fileName.value.substring(0, filenameExtensionIndex) : fileName.value}.${new_extension}`;

            fileName.value = new_label;
            record.label = new_label;

            CommonHelper.addFileInfoDocumentName(record);
          }

          if (new_extension) {
            if (new_extension === "zip") {
              const fileLatest = CommonHelper.storedFileLatest.value[documentIdValue];

              if (fileLatest && fileLatest[1] && fileLatest[1].size < 1000000000) {
                props.filePreview.downloadFileSaveZipFileData(documentIdValue, fileLatest[1].url);
              }
            } else if (old_extension === "zip") {
              CommonHelper.deleteZipFileData(documentIdValue);
            }
          }
        }
      }

      if (CommonHelper.storedFileLatest.value[documentIdValue]) {
        CommonHelper.storedFileLatest.value[documentIdValue] = CommonHelper.storedFileLatest.value[documentIdValue].filter((row) => {
          return row.id !== fileIdvalue;
        });
      }

      rowData.value = rowData.value.filter((row) => {
        return row.id !== fileIdvalue;
      });
    }

    function getFilenameExtension(filename) {
      let returnValue = "";

      const filenameExtensionIndex = filename.lastIndexOf('.');

      if (filenameExtensionIndex >= 0) {
        returnValue = filename.substring(filenameExtensionIndex + 1);
      }

      return returnValue;
    }

    async function updateRefsFromResponse(documentIdValue, response) {
      if (fileName.value !== response.data.document_name) {
        fileName.value = response.data.document_name;
      }

      const record = CommonHelper.tableInput.value.find((i) => {
        if (i.id === documentIdValue) {
          return i;
        }
      });

      if (record) {
        if (record.file_count !== Number(response.data.file_count_new)) {
          record.file_count = Number(response.data.file_count_new);
        }

        if (record.label !== response.data.document_name) {
          record.label = response.data.document_name;

          CommonHelper.addFileInfoDocumentName(record);
        }
      }

      if (response.data.file_count_new === "1") {
        fileVersionAdminDialog.value = false;
      }
    }

    return {
      //variable properties
      columnDefs,
      pagination,
      rowData,
      fileVersionAdminDialog,
      fileName,
      emphasizeFileId,
      hiddenFileId,
      deleteDialog,
      deleteDialogMessage,

      //functions
      openFileVersionAdmin,
      saveFileVersionData,
      deleteRow,
      deleteRecord
    };
  },
};
</script>